function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReconciliationTickOverlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66602C5.40835 1.66602 1.66669 5.40768 1.66669 9.99935C1.66669 14.591 5.40835 18.3327 10 18.3327C14.5917 18.3327 18.3334 14.591 18.3334 9.99935C18.3334 5.40768 14.5917 1.66602 10 1.66602ZM13.9834 8.08268L9.25835 12.8077C9.14169 12.9243 8.98335 12.991 8.81669 12.991C8.65002 12.991 8.49169 12.9243 8.37502 12.8077L6.01669 10.4493C5.77502 10.2077 5.77502 9.80768 6.01669 9.56602C6.25835 9.32435 6.65835 9.32435 6.90002 9.56602L8.81669 11.4827L13.1 7.19935C13.3417 6.95768 13.7417 6.95768 13.9834 7.19935C14.225 7.44102 14.225 7.83268 13.9834 8.08268Z",
    fill: "#BFD3F3",
    style: {
      fill: "#BFD3F3",
      fill: "color(display-p3 0.7490 0.8288 0.9529)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconciliationTickOverlay);
export default __webpack_public_path__ + "static/media/reconciliation_tick_overlay.d72786a95149a5f52bd00ffb4fe3a990.svg";
export { ForwardRef as ReactComponent };